import { module } from 'modujs';
import { $html } from '../utils/dom'

export default class CtaExperience extends module {

    static CLASS = {
        EXPERIENCE_HOVER: 'has-experience-button-hover',
    }

    constructor(m) {
        super(m);

        this.events = {
            mouseenter: {
                button: 'buttonMouseEnter',
            },
            mouseleave: {
                button: 'buttonMouseLeave'
            },
        }
    }

    init() {
    }

    destroy() {
        super.destroy()
    }

    buttonMouseEnter() {
        $html.classList.add(CtaExperience.CLASS.EXPERIENCE_HOVER)
    }

    buttonMouseLeave() {
        $html.classList.remove(CtaExperience.CLASS.EXPERIENCE_HOVER)
    }
}
